export default async function bootSetCookie(name,value,days) {
	let expires = '';
	if (days) {
		const date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    document.cookie = name+"="+value+expires+"; path=/";
}
